export default __webpack_public_path__ + "static/media/check-icon.07a25be3.svg";